import { render } from "./NavigationBar.vue?vue&type=template&id=c0b49bda&scoped=true&ts=true"
import script from "./NavigationBar.vue?vue&type=script&lang=ts"
export * from "./NavigationBar.vue?vue&type=script&lang=ts"

import "./NavigationBar.vue?vue&type=style&index=0&id=c0b49bda&scoped=true&lang=scss"

import exportComponent from "/builds/Moodbuster2.0/server/web-server/repos/patient_portal_vue/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c0b49bda"]])

export default __exports__